import NonFullWidthWrapper from '@/components/NonFullWidthWrapper'
import RichText from '@/components/RichText'
import UnknownComponent from '@/components/UnknownComponent'
import { GlossaryItemTagList } from '@/components/glossary/GlossaryItemTagList'
import { CommonCopyUrlWrapper } from '@/components/ui/copy-to-clipboard/CommonCopyUrlWrapper'
import { GlossaryResponseData } from '@/databuilders/glossary'
import { useCleanPathDefault } from '@/hooks/useCleanPathDefault'
import { Glossary } from '@/kontent/content-types'
import { CommonPageProps } from '@/types'
import { filterNonRedirectSyllabuses } from '@/utils'

export default function GlossaryPage({
	data: { pageResponse, syllabuses: allSyllabuses },
	preview,
}: CommonPageProps<Glossary, GlossaryResponseData>) {
	const currentUrl = useCleanPathDefault()
	const glossary = pageResponse?.item

	if (!glossary) {
		return (
			<UnknownComponent>Page does not have any content!</UnknownComponent>
		)
	}

	const filteredSyllabuses = filterNonRedirectSyllabuses(
		glossary.elements.syllabus.value,
		allSyllabuses,
		preview,
	)

	return (
		<>
			<CommonCopyUrlWrapper url={currentUrl} className="mb-4">
				<h1>
					{glossary.elements.title.value ||
						glossary.elements.title_system.value}
				</h1>
			</CommonCopyUrlWrapper>

			<NonFullWidthWrapper>
				<div
					key={glossary.system.id}
					className="glossary-body__definition"
					data-kontent-item-id={glossary.system.id}
				>
					<RichText
						richTextElement={glossary.elements.description}
						linkedItems={pageResponse.linkedItems}
						data-kontent-element-codename="description"
						mappings={[]}
					/>
					<GlossaryItemTagList
						className="mt-6"
						glossaryItem={{
							...glossary,
							elements: {
								...glossary.elements,
								syllabus: {
									...glossary.elements.syllabus,
									value: filteredSyllabuses,
								},
							},
						}}
					/>
				</div>
			</NonFullWidthWrapper>
		</>
	)
}
